<div class="container-fluid userfeedback-container">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-md-8 text-center">
                <div class="contact-dealer-form feedback-form">
                    <span class="login100-form-title new-title">Feedback</span> 
                    <div class="validate-form" style="margin-bottom: 0; margin-top:0">
                        <p style="font-size: 14px;color:green;font-weight:300;text-align: left;" *ngIf="feedbackSuccessMsg">
                            <i class="ti-face-smile" aria-hidden="true"></i>&nbsp;<span [innerHtml]="feedbackSuccessMsg"></span>
                        </p>
                        <p style="font-size: 14px;color:#db0c0c;font-weight:300;text-align: left;" *ngIf="feedbackErrorMsg">
                            <i class="ti-face-sad" aria-hidden="true"></i>&nbsp;<span [innerHTML]="feedbackErrorMsg"></span>
                        </p>
                    </div>
                    <form method="post" [formGroup]="feedback" (ngSubmit)="feedbackEnd()">
                        <!-- <div class="validate-form feedback-first newusercontainer">
                            <div class="w-ct">
                                <img src="assets/images/feedback.png" class="img-fluid" alt="feedback">
                                <h6 class="mt-md-3 mt-2">Hey, how was your <b>experience on Propira?</b></h6>
                            </div>
                            <div class="wrap-input100 input-wrapper">
                                <label><input id class="input100" type="radio" formControlName="rating" value="Awesome">
                                    Awesome <i class="fa fa-smile-o"></i></label>
                                <label><input class="input100" type="radio" formControlName="rating" value="Good"> Good
                                    <i class="fa fa-meh-o"></i></label>
                                <label><input class="input100" type="radio" formControlName="rating"
                                        value="Needs Improvement"> Needs
                                    Improvement <i class="fa fa-frown-o"></i></label>
                            </div>
                        </div> -->
                        <div class="validate-form feedback-first newusercontainer">
                            <div class="row align-items-center">
                                <div class="col-12 col-lg-7">
                                    <div class="w-ct">
                                        <img src="assets/images/feedback.png" class="img-fluid" alt="feedback">
                                        <h6 class="mt-md-3 mt-2">Hey, how was your <b>experience on Propira?</b></h6>
                                    </div>
                                </div>
                                <div class="col-12 col-lg-5 mt-3 mt-lg-0">
                                    <div class="wrap-input100 input-wrapper customInput row">
                                        <div class="col-12 px-0">
                                            <label><input id class="" type="radio" formControlName="rating" value="Awesome">
                                                Awesome <i class="fa fa-smile-o"></i></label>
                                        </div>
                                        <div class="col-12 px-0 my-2">
                                            <label><input class="" type="radio" formControlName="rating" value="Good"> Good
                                                <i class="fa fa-meh-o"></i></label>
                                        </div>
                                        <div class="col-12 px-0">
                                            <label><input class="" type="radio" formControlName="rating"
                                                value="Needs Improvement"> Needs Improvement <i class="fa fa-frown-o"></i></label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="validate-form feedback-second newusercontainer newusercontainer2 feedbackChange hide-div">
                            <img src="assets/images/feedback.png" class="img-fluid" loading="lazy" alt="feedback">
                            <h6><b>Thank you</b> for your <b>feedback!</b></h6>
                            <div class="wrap-input100 mt-4">
                                <input class="input100" type="tel" placeholder="Mobile" required
                                    formControlName="mobile" maxlength="10"
                                    onkeypress="return (!(event.charCode != 46 && event.charCode > 31  && (event.charCode < 48 || event.charCode > 57)))">
                                <span class="focus-input100"></span>
                                <span class="symbol-input100">
                                    <i class="ti-mobile" aria-hidden="true"></i>
                                </span>
                                <small class="error-msg" *ngIf="feedbackControl.mobile.touched && feedbackControl.mobile.errors">
                                    <p class="error mb-0" *ngIf="feedbackControl.mobile.errors.required">Mobile no is required</p>
                                    <p class="error mb-0" *ngIf="feedbackControl.mobile.errors.pattern">Enter Valid Mobile no.</p>
                                </small>
                            </div>
                            <div class="wrap-input100">
                                <input class="input100" type="email" placeholder="Email" required
                                    formControlName="email">
                                <span class="focus-input100"></span>
                                <span class="symbol-input100">
                                    <i class="ti-email" aria-hidden="true"></i>
                                </span>
                                <small class="error-msg" *ngIf="feedbackControl.email.touched && feedbackControl.email.errors">
                                    <p class="error mb-0">Enter Valid Email-Id</p>
                                </small>
                            </div>
                            <div class="wrap-input100">
                                <input class="input100" type="text" placeholder="Type your message..." required
                                    formControlName="message">
                                <span class="focus-input100"></span>
                                <span class="symbol-input100">
                                    <i class="ti-pencil" aria-hidden="true"></i>
                                </span>
                                <small class="error-msg" *ngIf="feedbackControl.message.touched && feedbackControl.message.errors">
                                    <p class="error mb-0">Enter Address</p>
                                </small>                                
                            </div>
                            <div class="container-login100-form-btn">
                                <button class="login100-form-btn" type="submit" (click)="sendOtp()">Submit <div class="box" *ngIf="feedbackLoader">
                                    <div class="loader-13"></div>
                                </div></button>
                            </div>
                        </div>
                    </form>
                    <div class="validate-form feedback-second newusercontainer otpVerification hide-div">
                        
                        <form class="newOtp" method="post" [formGroup]="feedbackverify" (ngSubmit)="chkFeedbackVerify()">
                            <span [innerHtml]="otpVerifymsg"></span>
                            <h6 class="mb-2 mt-sm-2 mb-sm-4 py-2"><b>OTP has been sent to your mobile XXXXXX{{(feedback.value.mobile).substring(6,10)}}, please enter
                                same
                                here to verify.</b></h6>
                                <input class="otp change" type="tel" name="pass1"  size="1"   maxlength=1  id="pass1" onkeypress="return /[0-9 ]/i.test(event.key)"  required>
                                <input class="otp change" type="tel" name="pass2"  size="1"   maxlength=1  id="pass2" onkeypress="return /[0-9 ]/i.test(event.key)"  required>
                                <input class="otp change" type="tel" name="pass3"  size="1"   maxlength=1  id="pass3" onkeypress="return /[0-9 ]/i.test(event.key)"  required>
                              
                            
                            <div class="wrap-input1002 ">
                                <p class="one_time_password2 mt-2 mb-0 text-danger" style="cursor:pointer" *ngIf="resendOtpTime==0"  (click)="sendOtp('resend')">
                                    RESEND (OTP)
                                </p>

                                <p class="one_time_password2 mt-2 mb-0 text-danger" *ngIf="resendOtpTime>0" >
                                    Resend in 00:{{("0" + resendOtpTime).slice(-2) }}
                                </p>

                            </div>
                            
                            <div class="container-login100-form-btn mt-2 mt-sm-4 pt-2">
                                <button class="login100-form-btn" type="button" (click)="otpVerify()" [disabled]="otpVerifyLoader">
                                    Submit
                                    <div class="box" *ngIf="otpVerifyLoader">
                                        <div class="loader-13"></div>
                                    </div>
                                </button>
                            </div>
                        </form>
                    </div>
                    <div class="validate-form feedback-second newusercontainer newusercontainer2 thankyouForm hide-div">
                        <img src="assets/images/thanku2.jpg" class="img-fluid thankyouImg" alt="feedback">
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>